import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import Typography from '../Typography';
import Colors from '../../theme/colors';
import Icon from '../Icon';

import StatusIcon from '../StatusIcon';
import StripSkeleton from '../SkeletonUI/SkeletonComponents/StripSkeleton';

import { StripProps } from './Strip.types';


const useStyles = makeStyles({
  root: {
    alignItems: 'flex-center',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    boxSizing: 'border-box',
    display: 'flex',
    fontSize: '10px',
    justifyContent: 'flex-start',
    minHeight: '28px',
    padding: '8px 16px'
  }
});

const Strip: React.FC<StripProps> = ({
  variant,
  className,
  text,
  showIcon,
  customIcon,
  children,
  rightContent,
  loading
}) => {
  const classes = useStyles();
  const iconClassName = 'mr2 primary Light200';

  if (loading) {
    return <StripSkeleton height={18} />
  }
  return (
    <>
      <div
        className={clsx(
          classes.root,
          'width-100 flex flex-center flex-justify',
          `${variant}-light-background`,
          className
        )}
      >
        <div className="flex flex-center">
          {showIcon &&
            (customIcon ? (
              <Icon {...customIcon} className={iconClassName} />
            ) : (
              <StatusIcon
                variant={variant}
                className={iconClassName}
                width={12}
                height={12}
              />
            ))}
          {text && (
            <Typography variant="Regular100" className="grey">
              {text}
            </Typography>
          )}
          {children}
        </div>
        {rightContent}
      </div>
    </>
  );
};

Strip.defaultProps = {
  variant: 'primary',
  showIcon: true,
  children: null,
  rightContent: null,
  loading: false
};

export default Strip;
export { StripProps };
